import Player from '@vimeo/player';
import YTPlayer from 'yt-player';

export default {
  init($element) {
  },
  finalize($element) {
    // Vimeo loader
    if ($element.find('.video-item')) {
      $element.find('.video-item').each(function() {
        const id = $(this).prop('id');
        const videoSource = $(this).data('source');
        const videoId = $(this).data('video-id');
        const $splashWrap = $(this).siblings('.video-splash-wrap');

        if (videoSource == 'vimeo') {
        
          // Init Vimeo
          const vimeoPlayer = new Player(id, {
            id: videoId,
          });

          $splashWrap.on('click', function() {
            $splashWrap.hide();
            vimeoPlayer.play();
          });

          vimeoPlayer.on('ended', function() {
            $splashWrap.show();
          });

        } else {

          // Init YouTube
          const ytPlayer = new YTPlayer(`#${id}`);
          ytPlayer.load(videoId);

          $splashWrap.on('click', function() {
            $splashWrap.hide();
            ytPlayer.play();
          });

          ytPlayer.on('ended', () => {
            $splashWrap.show();
          });

        }
      });
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/general/leftRightContent.js